/* import __COLOCATED_TEMPLATE__ from './loading-screen.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();